import type { AllRouteEndpoints } from "../routeTypes";

export const postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateCacheKeys: AllRouteEndpoints[] = [];
